<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button class="breadcrumb-back" @click="$router && $router.back ? $router.back() : window.history.back()">返回</button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.zhiwu }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.name }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">课务列表</span>
        </div>
        <!-- tab切换 -->
        <div class="tabs-bar">
          <span :class="['tab', activeTab === 'latest' ? 'active' : '']" @click="changeTab('latest')">最新</span>
          <span :class="['tab', activeTab === 'read' ? 'active' : '']" @click="changeTab('read')">阅读人数</span>
        </div>
        <!-- 课件列表 -->
        <div class="courseware-list">
          <div class="courseware-item" v-for="item in list" :key="item.id" @click="handleClickDetail(item)">
            <div class="item-left">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-info">
                <span class="item-read"><img src="@/assets/images/eye.png" class="info-icon" /> 阅读：<span class="green">{{ item.read }}</span></span>
                <span class="item-comment"><img src="@/assets/images/ly.png" class="info-icon" /> 留言：{{ item.comment }}</span>
                <span class="item-date"><img src="@/assets/images/time.png" class="info-icon" />{{ item.date }}</span>
              </div>
            </div>
            <el-button class="item-btn" size="mini" type="text">查看</el-button>
          </div>
          <div v-if="list.length === 0" class="no-data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          class="pagination-bar"
        />
      </div>
      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getKewuList, getEduDetails } from '@/axios/education'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      activeTab: 'latest', // 'latest' or 'read'
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      sort: 1, // 1:最新, 2:阅读人数
      teacher_id: parseInt(this.$route.query.teacher_id) || 1, // 默认1，实际应从路由获取
      teacherInfo: {
        name: '',
        zhiwu: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getTeacherInfo()
    this.getLists()
  },
  methods: {
    getTeacherInfo () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.teacher_id,
        type: 3
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = {
            name: data.realname || '',
            zhiwu: data.zhiwu || ''
          }
        }
      })
    },
    changeTab (tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab
        this.sort = tab === 'latest' ? 1 : 2
        this.page = 1
        this.getLists()
      }
    },
    getLists () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.teacher_id,
        page: this.page,
        sort: this.sort
      }
      const signO = sign(params)
      params.sign = signO
      getKewuList(params).then(res => {
        if (res.data.msg === '请求成功') {
          const data = res.data.data
          this.list = (data.lists || []).map(item => ({
            id: item.id,
            title: item.title,
            read: item.clickcount,
            comment: item.liuyancount,
            date: item.inputtime
          }))
          this.total = data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.list = []
        this.total = 0
      })
    },
    handleClickDetail (item) {
      this.$router.push({ name: 'SectionDetail', query: { id: item.id } })
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    }
  }
}
</script>

<style scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
}
.breadcrumb-back:hover {
  background: #f2f2f2;
  border-color: #ccc;
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #EF8432;
  font-weight: bold;
}
.tabs-bar {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
}
.tab {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
}
.tab.active {
  color: #EF8432;
  font-weight: bold;
  border-bottom: 2px solid #EF8432;
}
.courseware-list {
  margin-bottom: 20px;
}
.courseware-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,.05);
  padding: 16px 24px;
  margin-bottom: 16px;
  min-height: 56px;
}
.item-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  padding-top: 0;
}
.item-title {
  font-size: 16px;
  color: #181818;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 24px;
}
.item-info {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  color: #3D3D3D;
  margin-right: 16px;
  margin-top: 8px;
}
.item-read {
  color: #3DB963;
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-comment {
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-date {
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-btn {
  color: #EF8432;
  border: 1px solid #EF8432;
  background-color: rgb(253,242,234);
  border-radius: 4px;
  padding: 4px 18px;
  font-size: 14px;
  margin-left: 24px;
  height: 32px;
  display: flex;
  align-items: center;
  transition: background 0.2s;
  align-self: flex-start;
  margin-top: 0;
}
.item-btn:hover {
  background: #fff7f0;
  color: #EF8432;
  border-color: #EF8432;
}
.pagination-bar {
  text-align: center;
  margin-top: 20px;
}
.green {
  color: #3DB963;
}
.info-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 2px;
  vertical-align: middle;
}
.no-data {
  text-align: center;
  color: #aaa;
  margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/sectionList.vue